// ROGA VARIABLES

const DEV = "http://localhost:3001/api/v2";
// const ROGA_DEV = 'https://roga.docgo.com.br/api/v2';
const ROGA_PROD = "https://homologacao.docgo.com.br/api/v2";
const IMA_PROD = "https://api.ima.docgo.com.br/api/v2";
const PENEDO_PROD = "https://api.penedo.docgo.com.br/api/v2";
const HOMOLOG = "https://api.homolog.docgo.com.br/api/v2";
const MARECHAL_PROD = "https://api.marechal.docgo.com.br/api/v2";
const TEOTONIO_PROD = "https://api.teotonio.docgo.com.br/api/v2";

const API_V2_URL = () => {
  switch (location.hostname) {
    case "localhost":
      return DEV;
    case "homologacao.docgo.com.br":
      return ROGA_PROD;
    case "ima.docgo.com.br":
      return IMA_PROD;
    case "penedo.docgo.com.br":
      return PENEDO_PROD;
    case "marechal.docgo.com.br":
      return MARECHAL_PROD;
    case "teotonio.docgo.com.br":
      return TEOTONIO_PROD;
    case "homolog.docgo.com.br":
      return HOMOLOG;
    default:
      return DEV;
  }
};

export default API_V2_URL;



// WEBPACK FOOTER //
// ./src/constants/API_V2_URL.js